<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp text-center" data-wow-delay="0.1s">
  <div class="container text-center">
    <div class="row g-5 align-items-center">
      <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-4">
          {{ careersIntro.title }}
        </h1>
        <p>
          {{ careersIntro.brief }}
        </p>
      </div>
      <div class="col-lg-6 about-img wow fadeInUp" data-wow-delay="0.5s">
        <div class="row">
          <div class="col-12 text-center">
            <img
              class="img-fluid w-75 rounded-circle bg-light p-3"
              src="../../../assets/img/{{ careersIntro.image }}"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <br /><br /><br /><br />
    <div class="row g-4">
      <div
        *ngFor="let item of careersData"
        class="col-lg-6 col-md-6 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        <div class="classes-item">
          <div class="bg-light rounded p-4 pt-5 mt-n5">
            <a class="d-block text-center h3 mt-3 mb-4">{{ item.title }}</a>
            <p>{{ item.description }}</p>
            <a
              class="btn btn-primary rounded-pill py-3 px-5"
              (click)="generalApply()"
              >{{ "apply_now" | translate }}</a
            >
            <div class="row g-4 align-items-center">
              <div class="col-sm-6"></div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  </div>
</div>
<!-- Page content end -->
